function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Children, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import useDeviceDetect from "../../../hooks/useDeviceDetect";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import space, { spaceFactor } from "../../../utils/space";
import BreakpointVisibilityOrg from "../BreakpointVisibilityOrg";
import { Content } from "../ToggleSectionContainerOrg";
import ProductCardsSliderOrgArrow from "./ProductCardsSliderOrgArrow";
import { ProductCardsSliderOrgContextProvider } from "./ProductCardsSliderOrgContext";
export var mobileSlideWidthSpace = 28;
var mobileSlideGutterSpace = 2;
var desktopSlidesToShow = 4;
var desktopSlideGutterSpace = 4;
var additionalSafeSpace = 20; /* Additional space for box-shadow and hover state of items so that they're not hidden through overflow: hidden */
var minimalAdditionalSafeSpace = 2; /* Minimal additional space only for box-shadow of items  */
var arrowsSpace = 3; /* Space needed for arrows to fit */

/**
 * 1. Needed to prevent hiding of overflown elements by section below
 * 2. Styles needed to ensure that all slides have equal heights when the slider is loading
 * 3. Fixes problem with overlapping container over other clickable ToggleSectionContainerOrgs on mobile so they weren't clickable anymore
 * */
/* stylelint-disable no-duplicate-selectors */
var StyledSlider = styled(Slider).withConfig({
  componentId: "sc-6khyuw-0"
})(["display:flex !important;flex-wrap:wrap;justify-content:flex-end;.slick-list{flex-grow:1;overflow:inherit;", "{margin:", " ", ";padding:", " 0;overflow:hidden;}", " &{", "{margin-top:", ";margin-bottom:", ";padding-top:", ";padding-bottom:", ";}}", "{margin-right:", ";margin-left:", ";}}.slick-arrow{z-index:1;~ .slick-list{", "{margin-top:", ";}", "{margin-top:", ";}", " &{", "{margin-top:", ";}}}&.slick-prev{order:-2;}&.slick-next{order:-1;}}.slick-track{display:flex;margin:0;&:hover{z-index:3;}}.slick-slide{height:auto;padding-right:", ";padding-left:", ";", "{box-sizing:content-box;&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}}", "{padding:0 ", ";}> div{height:100%;> :only-child{height:100%;> :only-child{height:100%;}}}}.slick-track,.slick-list{transform:none !important;}"], breakpoint("large"), space(-1 * additionalSafeSpace), space(-1 * pageGutterSpace), space(additionalSafeSpace), Content, breakpoint("small", "medium"), space(-1 * minimalAdditionalSafeSpace), space(-1 * minimalAdditionalSafeSpace), space(minimalAdditionalSafeSpace), space(minimalAdditionalSafeSpace), breakpoint("large"), space(-1 * desktopSlideGutterSpace / 2), space(-1 * desktopSlideGutterSpace / 2), breakpoint("large"), space(-1 * additionalSafeSpace + arrowsSpace), breakpoint("small", "medium"), space(4), Content, breakpoint("small", "medium"), space(-1 * minimalAdditionalSafeSpace + arrowsSpace), space(mobileSlideGutterSpace - pageGutterSpace), space(pageGutterSpace), breakpoint("small", "large"), breakpoint("large"), space(desktopSlideGutterSpace / 2));
function ProductCardsSliderOrg(_ref) {
  var children = _ref.children;
  var containerRef = useRef(null);
  var _useState = useState(desktopSlidesToShow),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfVisibleSlides = _useState2[0],
    setNumberOfVisibleSlides = _useState2[1];
  var _useDeviceDetect = useDeviceDetect(),
    isDesktop = _useDeviceDetect.isDesktop;
  var countVisibleSlides = function countVisibleSlides() {
    var _containerRef$current;
    var containerWidth = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
    if (containerWidth) {
      return Math.floor((containerWidth + mobileSlideGutterSpace * spaceFactor) / ((mobileSlideWidthSpace + mobileSlideGutterSpace) * spaceFactor));
    }
    return 0;
  };
  var elementWrapperWidth = mobileSlideWidthSpace * spaceFactor;
  var showArrowsInDesktop = React.Children.count(children) > desktopSlidesToShow;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showArrows = _useState4[0],
    setShowArrows = _useState4[1];
  var checkWidth = function checkWidth() {
    var windowWidth = window.innerWidth;
    var containerWidth = React.Children.count(children) * elementWrapperWidth;
    if (containerWidth > windowWidth) {
      setShowArrows(true);
    } else {
      setShowArrows(false);
    }
  };
  useEffect(function () {
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return function () {
      window.removeEventListener("resize", checkWidth);
    };
  }, []);
  var sliderParameters = {
    infinite: false,
    draggable: false,
    useTransform: false,
    prevArrow: /*#__PURE__*/React.createElement(ProductCardsSliderOrgArrow, {
      direction: "left"
    }),
    nextArrow: /*#__PURE__*/React.createElement(ProductCardsSliderOrgArrow, {
      direction: "right"
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(ProductCardsSliderOrgContextProvider, null, /*#__PURE__*/React.createElement(StyledSlider, _extends({}, sliderParameters, {
    arrows: showArrowsInDesktop,
    slidesToShow: desktopSlidesToShow,
    slidesToScroll: desktopSlidesToShow
  }), children))), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, /*#__PURE__*/React.createElement(ProductCardsSliderOrgContextProvider, null, /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(StyledSlider, _extends({}, sliderParameters, {
    arrows: isDesktop && showArrows,
    variableWidth: true,
    slidesToShow: numberOfVisibleSlides,
    slidesToScroll: numberOfVisibleSlides,
    onReInit: function onReInit() {
      return setNumberOfVisibleSlides(countVisibleSlides());
    }
  }), Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: elementWrapperWidth
      }
    }, child);
  }))))));
}
export default ProductCardsSliderOrg;